module.exports = __webpack_public_path__ + "static/media/SmartShop_7-1080w.d59ea605.jpg";